// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"d0a812af","1594":"ebbd46be","5582":"d1cde583"}[chunkId] + ".chunk.css";
};